<div class="hf-plan-slider-wrapper">
  <div class="swiper-container" [swiper]="config">
    <div class="swiper-wrapper">
      <ng-container *ngFor="let item of plans; index as i">
        <div class="plan-item swiper-slide" (click)="onPlanClicked(item, i)">
          <div class="img-wrapper">
            <img [src]="item?.info_1" alt="image" [attr.img]="item.info_1">
          </div>
          <div class="title" [innerHTML]="item?.info_2">
          </div>
          <div class="desc">
            <div class="text">
              {{item?.info_3}}
            </div>
            <div class="icon">
              <mat-icon>arrow_forward</mat-icon>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
  <!-- <ngx-glide [showArrows]="false" type="carousel" [showBullets]="false" [gap]="util.isMobile() ? 8: 20" [perView]="util.isMobile() ? 2.2: 7" [perTouch]="1" [keyboard]="false"> -->
    
  <!-- </ngx-glide> -->
</div>